<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchTitle"></breadcrumb-search>
      <div style="display: flex; padding-bottom: 24px">
        <div v-for="(item, index) in records" :key="index" class="record-item">
          <div>
            <img style="width: 56px; height: 56px" :src="item.img" />
          </div>
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <div class="price">
              <span style="font-size: 16px">￥</span>{{ item.price }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <h3>数据筛选</h3>
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small">
          <el-form-item label="时间" prop="createdTimeStart" style="max-width: 370px">
            <el-date-picker style="width: 246px" v-model="value1" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy - MM - dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input placeholder="请输入商品名称" v-model="searchForm.goodsName"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select v-model="searchForm.type" placeholder="请选择类型" filterable clearable>
              <el-option label="充值" value="1"></el-option>
              <!-- <el-option label="提现" value="2"></el-option> -->
              <el-option label="冻结" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="searchForm.status" placeholder="请选择状态" filterable clearable>
              <el-option label="已冻结" value="1"></el-option>
              <el-option label="已释放" value="2"></el-option>

              <el-option label="已到账" value="5"></el-option>
              <!-- <el-option
                v-for="item in dictionaries.platform_earnest_status"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId"
              >
              </el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item class="form-btn">
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content" style="min-height: 420px">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <el-button type="warning" @click="frozen()">充值</el-button>
          <el-button type="warning" @click="todetail">冻结金额</el-button>
          <el-button type="primary" icon="el-icon-upload2" :loading="exporting" @click="exportFn">导出</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage" :page-size="page.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
    <el-dialog title="充值保证金" :visible.sync="isFrozen" width="526px" :append-to-body="true">
      <template>
        <el-form>
          <el-form-item label="充值金额">
            <div style="display: flex; flex-wrap: wrap">
              <div v-for="(item, index) in price" :key="index" style="cursor: pointer"
                :class="[inx === index ? 'c-item' : 'w-item']" @click="selectPrice(index)">
                {{ item }}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="充值平台">
            <!-- <el-radio-group> -->
            <el-radio v-model="payType" label="1">微信</el-radio>
            <!-- <el-radio label="支付宝"></el-radio> -->
            <!-- </el-radio-group> -->
          </el-form-item>

          <el-form-item label="二维码：" v-if="inx !== null">
            <div style="display: flex">
              <div style="width: 160px; height: 160px; border: 1px solid #2d46ee">
                <img :src="codeUrl" style="width: 160px; height: 160px" />
              </div>
              <div>
                <div style="display: flex; margin-top: 73px; cursor: pointer" @click="frozen()">
                  <img src="../../../assets/icon_shuaxin.png" style="width: 16px; height: 16px; margin-left: 18px" />
                  <div class="erweima" @click="getRechargeInfo">刷新二维码</div>
                </div>
                <div class="frozen">请扫码支付充值金额！</div>
              </div>
            </div>
          </el-form-item>
        </el-form>

        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="hideFrozen">取消</div>
          <div class="info-s" @click="hideFrozen">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
import common from '../../../mixins/common.js'
export default {
  mixins: [common],
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data() {
    return {
      isFrozen: false,
      price: [0.01, 100, 500, 1000, 2000, 5000, 10000],
      inx: null,
      dataList: {
        list: [
          { title: '财务管理', path: '', type: '0' },
          { title: '平台保证金', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '数据筛选', path: '', type: '0' }
        ]
      },
      records: [
        {
          img: require('../../../assets/icon_yichongzhi.png'),
          title: '已充值金额',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_dongjie.png'),
          title: '冻结金额',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_keyong.png'),
          title: '可用金额',
          price: '10000'
        },
      ],
      searchTitle: {
        list: [
          { title: '平台保证金', path: '', type: '0' }
        ]
      },
      list: [],
      searchForm: {
        createdTimeStart: '', // 	最近充值时间-开始
        createdTimeEnd: '', // 	最近充值时间-结束
        goodsName: '', // 	商品名称
        type: '', // 	类型 1充值 2提现 3冻结
        status: '' // 	状态  字典：platform_earnest_status
      },
      value1: [],
      brandList: [],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '时间', prop: 'updatedTime', minWidth: '120' },
        { label: '类型', prop: 'typeLabel', minWidth: '120' },
        {
          label: '方式', prop: 'payType', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.payType || '--'}</span>
              </div>
            )
          }
        },
        { label: '商品', prop: 'goodsName', minWidth: '220' },
        { label: '数量', prop: 'goodsNum', minWidth: '120' },
        { label: '金额（元）', prop: 'modifyAmount', minWidth: '150' },
        {
          label: '状态', prop: 'statusLabel', minWidth: '80',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.statusLabel == '已冻结') {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center"><div style="width: 10px;height: 10px;background: #FF9226;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center"><div style="width: 10px;height: 10px;background:  #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            }
            return (
              <div> {vv}</div>

              // <p style="color:#303033;font-size:14px;">{scope.row.verifyStatusLabel}</p>
            )
          }
        },
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      exporting: false,
      payType: '1',
      rechargeInfo: {},
      codeUrl: '',
      timer: null
    }
  },
  created() {
    console.log(this.payType)
    this.getPlatformStatistics()
    this.getEarnestMoneyList()
  },
  destroyed() {
    console.log('销毁了吗')
    this.hideFrozen()
    this.inx = null
  },
  methods: {
    getRechargeInfo() {
      let data = {
        payType: this.payType,
        amount: this.price[this.inx]
      }
      this.axios.post('/earnestMoney/getRechargeInfo', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.rechargeInfo = res.data;
            this.getCode(this.rechargeInfo.paymentNo)
            this.timer = setInterval(() => {
              this.getPaymentResult()
            }, 5000)
          }
        })
    },
    getPaymentResult() {
      this.axios.get('/earnestMoney/getPaymentResult?paymentNo=' + this.rechargeInfo.paymentNo, { headers: { isLoading: false } })
        .then(res => {
          console.log(res)
          if (res.data.status == 1 || res.data.status == 2) {
            this.hideFrozen()
          }
          if (res.data.status == 1) {
            clearInterval(this.timer)
            this.timer = null;
            this.$message.success('支付成功!')

            this.getPlatformStatistics()
            this.fetchData('reset')
          }
          if (res.data.status == 2) {
            this.$message.warning('还未支付成功，请等待或者重新支付')
          }

        })
    },
    hideFrozen() {
      clearInterval(this.timer)
      this.timer = null;
      this.isFrozen = false
    },
    //获取支付二维码
    getCode(paymentNo) {
      this.codeUrl = `${process.env.VUE_APP_API_BASE_URL}/earnestMoney/wx${paymentNo}QrcodeImage.jpg?v='${Math.random()}`
      console.log(this.codeUrl)
    },
    exportFn() {
      this.exporting = true
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.createdTimeStart = this.value1[0];
        this.searchForm.createdTimeEnd = this.value1[1]
      } else {
        this.searchForm.createdTimeStart = ''
        this.searchForm.createdTimeEnd = ''
      }
      this.axios.post('/earnestMoney/exportList', this.searchForm)
        .then(res => {
          console.log(res)
          this.exporting = false;
          if (res.code === 0) {
            this.downloadlink(res.data)
          }
        })
    },
    fetchData(type) {
      this.page.pageNo = 1;
      if (type == 'reset') {
        this.$refs['searchForm'].resetFields()
        this.value1 = []
      }
      this.getEarnestMoneyList()
      this.getPlatformStatistics()
    },
    getEarnestMoneyList() {
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.createdTimeStart = this.value1[0];
        this.searchForm.createdTimeEnd = this.value1[1]
      } else {
        this.searchForm.createdTimeStart = ''
        this.searchForm.createdTimeEnd = ''
      }
      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.axios.post('/earnestMoney/getPageList', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code === 0) {
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    },
    onMultipleSelection(e) { },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.getEarnestMoneyList()
      this.getPlatformStatistics()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getEarnestMoneyList()
      this.getPlatformStatistics()
    },
    getPlatformStatistics() {
      this.axios.get('/earnestMoney/getPlatformStatistics')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.records[0].price = res.data.hadRechargeAmount;
            this.records[1].price = res.data.awaitEarnestMoney;
            this.records[2].price = res.data.activeEarnestMoney;
          }
        })
    },
    selectPrice(index) {
      this.inx = index;
      this.getRechargeInfo()
    },
    frozen() {
      this.isFrozen = true;
      // this.getRechargeInfo()
    },
    todetail() {
      this.$router.push({
        name: 'frozenAmount',
        query: {}
      })
    }
  }
}
</script>

<style scoped lang="scss">
.erweima {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 18px;
  color: #2d46ee;
}

.frozen {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #909099;
  margin-left: 18px;
  margin-top: 60px;
}

.w-item {
  width: 86px;
  height: 36px;
  background: #e9ecfe;
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 36px;
  color: #303033;
  text-align: center;
  margin-right: 18px;
  margin-top: 10px;
}

.c-item {
  width: 86px;
  height: 36px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 36px;
  color: #ffffff;
  text-align: center;
  margin-right: 18px;
  margin-top: 10px;
}

::v-deep .el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;

  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }

  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    white-space: normal;
  }
}

::v-deep .el-dialog__header {
  text-align: left;
  border-bottom: none;
}

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #303033;
  opacity: 1;
  text-align: left;
}

.info-b {
  margin-left: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: #303033;
  text-align: left;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.record-item {
  display: flex;
  width: 313px;
  height: 88px;
  background: #ffffff;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.05);
  opacity: 1;
  border-radius: 6px;
  margin-right: 18px;

  img {
    padding: 16px 14px;
  }

  .right {
    margin-top: 16px;

    .title {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 21px;
      color: #303033;
    }

    .price {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 31px;
      color: #303033;
      margin-top: 8px;
    }
  }
}

.title {
  display: flex;
  justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: nowrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 70px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 70px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }

  .el-form-item.form-btn {
    /deep/ .el-form-item__content {
      display: block;
      margin-left: 0px;
    }
  }
}

/deep/ .el-table {
  color: #303033;
}
</style>

